import RefreshIcon from '@/assets/refresh.svg?react'
import clsx from 'clsx'
import { Variants } from 'motion/react'
import { useMemo } from 'react'
import ClickWrapper, { ClickWrapperProps } from './ClickWrapper'
import styles from './ServiceWorkerUpdateTip.module.css'

export interface ServiceWorkerUpdateTipProps extends ClickWrapperProps {
	show?: boolean
	onClick?: () => void
}

// 处理图标和渐变的子组件
function GradientIcon() {
	return (
		<div className={styles.iconContainer}>
			<RefreshIcon className={styles.icon} />
			{/* 添加 SVG 渐变定义 */}
			<svg width="0" height="0">
				<defs>
					<linearGradient id="sw-icon-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
						<stop offset="0%" stopColor="var(--tint-jike-yellow)" />
						<stop offset="100%" stopColor="var(--tint-jike-blue)" />
					</linearGradient>
				</defs>
			</svg>
		</div>
	)
}

// 处理内容的子组件
function Content() {
	return (
		<div className={styles.content}>
			<div className={styles.contentText}>新版已就绪</div>
		</div>
	)
}

export default function ServiceWorkerUpdateTip({
	show = false,
	onClick,
	className,
	...props
}: ServiceWorkerUpdateTipProps) {
	const animationProps: Variants = useMemo(
		() => ({
			initial: {
				opacity: 0,
				y: '100%',
			},
			animate: {
				opacity: 1,
				y: !show ? '100%' : 0,
				transition: {
					duration: 0.6,
					type: 'spring',
					damping: 20,
				},
			},
		}),
		[show]
	)

	return (
		<ClickWrapper
			whileTap={{
				scale: 0.98,
			}}
			onClick={onClick}
			className={clsx(styles.root, className)}
			{...animationProps}
			{...props}
		>
			<GradientIcon />
			<Content />
		</ClickWrapper>
	)
}
